// import { Message } from 'element-ui';
import downloadjs from 'downloadjs'

export function readFile(res, name) {
  return new Promise((reslove, reject) => {
    const reader = new FileReader();

    reader.readAsText(res);
    reader.onload = function() {
      try {
        const text = JSON.parse(reader.result);

        // Message.error(text.message);
        reject(text);
      } catch (err) {
        downloadjs(res, `${name}`);
        reslove();
      }
    };
    reader.onerror = function(e) {
      console.log('Error', e);
      reject();
    };
  });
}
